import { render, staticRenderFns } from "./AddressManager.vue?vue&type=template&id=bbad58fc"
import script from "./AddressManager.vue?vue&type=script&lang=js"
export * from "./AddressManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports